/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const form3Slice = createSlice({
  name: 'form3',
  initialState: {
    planName: '',
    selectedPeriodicity: '',
    firstPayment: '',
    paymentAmount: '',
    totalPayment: '',
    coverageObject: null,
  },
  reducers: {
    setForm3Data(state, { payload }) {
      state.planName = payload.planName;
      state.selectedPeriodicity = payload.selectedPeriodicity;
      state.firstPayment = payload.firstPayment;
      state.paymentAmount = payload.paymentAmount;
      state.totalPayment = payload.totalPayment;
      state.coverageObject = payload.coverageObject;
    },
  },
});

export const form3Actions = form3Slice.actions;

export default form3Slice;
/* eslint-enable no-param-reassign */
